import { type TemplateResult, html } from 'lit';
import { customElement } from 'lit/decorators.js';
import { TailwindElement } from '../../shared/tailwind.element';

import '../dialogs/dialog';
import { CustomEventNames } from '../../constants/custom-event-names';
import { ContinueUrl } from '../../constants/constants';

@customElement('szw-ba-resume-button')
export class SzwBaResumeButton extends TailwindElement() {
	handleClick(): void {
		this.showEnterCodeDialog();
	}

	handleKeyDown(event: KeyboardEvent): void {
		if (event.code === 'Enter') {
			this.showEnterCodeDialog();
		}
	}

	showEnterCodeDialog(): void {
		const event = new CustomEvent(CustomEventNames.ShowEnterCodeDialog, { bubbles: true, composed: true });
		this.dispatchEvent(event);
	}

	handleContinueButtonClick(): void {
		window.location.href = ContinueUrl;
	}

	render(): TemplateResult {
		const responseCode = localStorage.getItem('responseCode');
		return html` <div class="flex flex-col gap-4">
				${responseCode != null
					? html`<button type="button" @click=${this.handleContinueButtonClick} class="btn btn--secondary w-full">
							Verder gaan met laatste sessie
					  </button>`
					: null}
				<button
					type="button"
					@click=${this.handleClick}
					@keypress=${this.handleKeyDown}
					class="btn btn--secondary w-full"
				>
					Verder gaan met code
				</button>
			</div>
			<szw-ba-dialog></szw-ba-dialog>`;
	}
}

declare global {
	interface HTMLElementTagNameMap {
		'szw-ba-resume-button': SzwBaResumeButton;
	}
}
